<template>
    <div class="insurance-status-setting">
				<StatusMenu :tab_name="'insuranceStatus'"  v-if="_gAuth.isAppSas()"/>
        <CreateNewInsuranceStatusModal :create_new_insurance_status.sync="modals.create_new_insurance_status"  v-on:closeModal="closeModal()"  />
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <h2 class="listing-title d-inline-block mb-0">Insurance Status Setting</h2>
                </b-col>
                <b-col cols="6" class="text-right ">
                    <b-button variant="primary" class="btn-header" @click="openModal">Create New</b-button>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <InsuranceStatusTable />
        </b-container>
    </div>
</template>
<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import StatusMenu from '@/views/Configurations/StatusMenu'
import InsuranceStatusTable from '@/views/Configurations/InsuranceStatusSettings/InsuranceStatusTable'
import CreateNewInsuranceStatusModal from '@/views/Configurations/InsuranceStatusSettings/InsuranceStatusModals/CreateNewInsuranceStatusModal'

export default {
    components: {
        InsuranceStatusTable,
        RouteBreadCrumb,
        CreateNewInsuranceStatusModal,
				StatusMenu
    },
    data() {
        return {
            modals: {
                create_new_insurance_status: false
            }
        }
    },
    methods: {
        openModal() {
            this.modals.create_new_insurance_status = true;
        },
        closeModal(){
            this.modals.create_new_insurance_status = false;
        },
    }
}
</script>